// react
import React from 'react'

// components
import { Dialog3 as Dialog } from '@st-operations/uikit/src/v1/index.js'
import Header from '_components/header/index.jsx'
import NewEntityDialog from '_components/new-entity-dialog/index.jsx'
import ListView from '_components/list-view/index.jsx'

// The partners an audience can be listed under in salesforce. Each destination is
// assigned one on its own page
class SalesforceIntegrationPartnersPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      modalOpen: false,
    }
  }

  toggleModal = () => {
    this.setState((prevState) => ({
      modalOpen: !prevState.modalOpen,
    }))
  }

  render() {
    return (
      <div id="salesforce-integration-partners-page">
        <Header
          title="Salesforce Integration Partners"
          actions={[
            {
              children: 'Create New Partner',
              onClick: this.toggleModal,
            },
          ]}
        />

        <ListView
          columns={[
            {
              name: 'Name',
              key: 'name',
              link: `/salesforce-integration-partners/:_id`,
              sortable: true,
            },
            {
              format: 'date',
              key: 'updated_at',
              name: 'Last Updated',
              sortable: true,
            },
          ]}
          entities="salesforce-integration-partners"
          fields={['name', 'updated_at']}
          searchable={true}
          sort_dir={1}
          sort_key={'name'}
        />
        <Dialog open={this.state.modalOpen} close={this.toggleModal}>
          <NewEntityDialog
            close={this.toggleModal}
            entities="salesforce-integration-partners"
            title="Enter the partner's name, exactly as Salesforce spells it"
          />
        </Dialog>
      </div>
    )
  }
}

// export
export default SalesforceIntegrationPartnersPage
